import { utils } from '@hh/global.js';
const { throttle } = utils
class HHCharacter extends HTMLElement {
  constructor() {
    super()

    this.wrapper = this.querySelector('[data-character-wrapper]')
    this.slider = this.querySelector('[data-character-slider]')
    this.slides = this.querySelectorAll('[data-character-slide]')
    this.buttons = this.querySelectorAll('[data-character-button]')
    this.contentWrapper = this.querySelector('[data-character-content-wrapper]')
    this.pagination = this.querySelector('[data-character-pagination]')
    this.paginationInner = this.querySelector(
      '[data-character-pagination-inner]'
    )
    this.paginationPlaceholder = this.querySelector(
      '[data-character-pagination-placeholder]'
    )
    this.characterPaginationButtons = this.querySelectorAll(
      '[data-character-pagination-button]'
    )
    this.sliderPaginationButtons = this.querySelectorAll(
      '[data-slider-pagination-button]'
    )

    this.throttleScroll = throttle(this.handleScroll.bind(this), 100)
    this.paginationThrottleScroll = throttle(
      this.handlePaginationScroll.bind(this),
      100
    )

    this.currentSlide = this.slides[0]
    this.totalSlides = this.slides.length

    this.navType = this.getAttribute('nav-type')

    this.classes = {
      active: 'active',
    }
  }

  connectedCallback() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleButtonClick.bind(this))
      button.addEventListener('focus', (e) => {
        e.target.dispatchEvent(
          new CustomEvent('click', {
            bubbles: true,
            composed: true,
            detail: {
              customEvent: e,
            },
          })
        )
      })
      button.addEventListener('keydown', this.handleEnterKey.bind(this))
    })

    this.slider.addEventListener('scroll', this.throttleScroll)
    this.paginationInner.addEventListener(
      'scroll',
      this.paginationThrottleScroll
    )

    setTimeout(() => {
      this.handleMobilePaginationPosition()
    }, 1000)
    setTimeout(() => {
      this.handleMobilePaginationPosition()
    }, 2000)
    window.addEventListener(
      'resize',
      this.handleMobilePaginationPosition.bind(this)
    )

    this.characterPaginationButtons.forEach((button) => {
      button.addEventListener(
        'click',
        this.handleCharacterPaginationClick.bind(this)
      )
    })

    this.sliderPaginationButtons.forEach((button) => {
      button.addEventListener(
        'click',
        this.handleSliderPaginationClick.bind(this)
      )
    })

    this.toggleTabIndex(this.currentSlide)
  }

  disconnectedCallback() {
    this.buttons.forEach((button) => {
      button.removeEventListener('click', this.handleButtonClick)
      button.removeEventListener('focus', (e) => {
        e.target.dispatchEvent(
          new CustomEvent('click', {
            bubbles: true,
            composed: true,
            detail: {
              customEvent: e,
            },
          })
        )
      })
      button.removeEventListener('keydown', this.handleEnterKey.bind(this))
    })

    this.slider.removeEventListener('scroll', this.throttleScroll)
    this.paginationInner.removeEventListener(
      'scroll',
      this.paginationThrottleScroll
    )

    window.removeEventListener(
      'resize',
      this.handleMobilePaginationPosition.bind(this)
    )

    this.characterPaginationButtons.forEach((button) => {
      button.removeEventListener('click', this.handleCharacterPaginationClick)
    })

    this.sliderPaginationButtons.forEach((button) => {
      button.removeEventListener('click', this.handleSliderPaginationClick)
    })
  }

  handleEnterKey(e) {
    if (e.keyCode !== 'Enter' && e.which !== 13) return

    e.preventDefault()
    const { currentTarget } = e
    const index = currentTarget.dataset.characterButton
    const slide = this.querySelector(`[data-character-slide="${index}"]`)

    slide.focus()
  }

  handleButtonClick(e) {
    e.preventDefault()

    const { currentTarget } = e
    const index = currentTarget.dataset.characterButton
    const slide = this.querySelector(`[data-character-slide="${index}"]`)

    this.setCurrentSlide(slide, e)
  }

  handleScroll() {
    const scrollPosition = this.slider.scrollLeft
    const slideWidth = this.slides[0].offsetWidth
    const index = Math.round(scrollPosition / slideWidth)
    const button = this.querySelector(`[data-character-button="${index + 1}"]`)

    this.buttons.forEach((button) => {
      button.classList.remove(this.classes.active)
      button.setAttribute('aria-current', false)
    })

    button?.classList.add(this.classes.active)
    button?.setAttribute('aria-current', true)

    this.setActiveButton(button)
    this.checkBeginningOrEnd(scrollPosition)

    if (this.navType === 'dots') {
      this.sliderPaginationButtons.forEach((button) => {
        button.classList.add(this.classes.active)
      })
    }
  }

  handleMobilePaginationPosition() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1023px)')
    const isMobile = mobileMediaQuery.matches

    if (isMobile) {
      const wrapperRect = this.wrapper.getBoundingClientRect()
      const placeholderRect = this.paginationPlaceholder.getBoundingClientRect()
      const navTypeOffset = this.navType === 'dots' ? 0 : 35

      const distance = placeholderRect.top - wrapperRect.top - navTypeOffset

      this.pagination.style.top = `${distance}px`
      this.pagination.style.position = 'absolute'
      this.pagination.style.display = 'flex'

      setTimeout(() => {
        const { scrollWidth, offsetWidth } = this.paginationInner
        const isOverflowing = scrollWidth > offsetWidth

        console.log({ isOverflowing, scrollWidth, offsetWidth })

        if (isOverflowing) {
          this.paginationInner.style.justifyContent = 'flex-start'
        }
      }, 200)
    } else {
      this.pagination.style = ''
      this.paginationInner.style = ''
    }
  }

  handleCharacterPaginationClick(e) {
    const { currentTarget } = e
    const direction = currentTarget.name
    const scrollDistance = this.buttons[0].offsetWidth * 2

    this.paginationInner.scrollBy({
      left: direction === 'next' ? scrollDistance : -scrollDistance,
      behavior: 'smooth',
    })
  }

  handleSliderPaginationClick(e) {
    const { currentTarget } = e
    this.sliderPaginationButtons.forEach((button) => {
      button.classList.add(this.classes.active)
    })

    const direction = currentTarget.name
    const scrollDistance = this.slides[0].offsetWidth

    this.slider.scrollBy({
      left: direction === 'next' ? scrollDistance : -scrollDistance,
      behavior: 'smooth',
    })
  }

  setCurrentSlide(slide, customEvent) {
    const scrollPosition = [...this.slides].indexOf(slide) * slide.offsetWidth

    this.slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth',
    })

    this.slides.forEach((slide) => {
      slide.setAttribute('aria-hidden', true)
    })

    slide.setAttribute('aria-hidden', false)

    // focus on slide
    slide.setAttribute('tabindex', 0)
    if (customEvent?.detail?.customEvent?.type !== 'focus') {
      slide.focus()
    }

    setTimeout(() => {
      slide.removeAttribute('tabindex')
    }, 1000)

    this.toggleTabIndex(slide)
  }

  toggleTabIndex(activeSlide) {
    // Helper function to set tabindex for all elements matching a selector
    const setTabIndex = (root, selector, tabIndex) => {
      const elements = root.querySelectorAll(selector)
      elements.forEach((element) => {
        const target = element.shadowRoot
          ? element.shadowRoot.querySelector('summary')
          : element
        target.setAttribute('tabindex', tabIndex)
      })
    }

    // Change tabindex to -1 for all slide accordions and links
    setTabIndex(this, 'hh-accordion', -1)
    setTabIndex(this, 'a', -1)

    // Change tabindex to 0 for active slide accordions and links
    setTabIndex(activeSlide, 'hh-accordion', 0)
    setTabIndex(activeSlide, 'a', 0)
  }

  setActiveButton(button) {
    if (!button) return

    this.buttons.forEach((button) => {
      button.classList.remove(this.classes.active)
      button.setAttribute('aria-current', false)
    })

    button.classList.add(this.classes.active)
    button.setAttribute('aria-current', true)
  }

  checkBeginningOrEnd(currentScrollPosition) {
    if (!this.sliderPaginationButtons.length) return

    const scrollWidth = this.slider.scrollWidth
    const slideWidth = this.slides[0].offsetWidth
    const isBeginning = currentScrollPosition <= slideWidth / 2
    const isEnd = currentScrollPosition >= scrollWidth - slideWidth * 1.5

    this.sliderPaginationButtons.forEach((button) => {
      button.disabled = false
    })

    this.sliderPaginationButtons[0].disabled = isBeginning
    this.sliderPaginationButtons[1].disabled = isEnd
  }

  handlePaginationScroll() {
    if (!this.characterPaginationButtons.length) return
    if (this.navType === 'dots') return

    const scrollPosition = this.paginationInner.scrollLeft
    const scrollWidth = this.paginationInner.scrollWidth
    const clientWidth = this.paginationInner.clientWidth
    const buttonSize = this.buttons[0].offsetWidth
    const isBeginning = scrollPosition <= buttonSize / 2
    const isEnd = scrollPosition >= scrollWidth - clientWidth - buttonSize / 2

    this.characterPaginationButtons.forEach((button) => {
      button.disabled = false
    })

    this.characterPaginationButtons[0].disabled = isBeginning
    this.characterPaginationButtons[1].disabled = isEnd
  }
}

if (!customElements.get('hh-character')) {
  customElements.define('hh-character', HHCharacter)
}
